export default __webpack_public_path__ + "5803e5df71dea25cf80923ef02ab02e9.gif";